import React from 'react';
import CreatableSelect from 'react-select/creatable';
import { components } from 'react-select';

const CustomMenuList = ({ showLabel, menuLabel, ...props }) => {
  return (
    <>
      {showLabel && (
        <div
          style={{
            padding: '8px',
            fontWeight: 'bold',
            color: '#555',
            fontSize: '14px',
            background: '#f8f9fa',
            borderRadius: '10px 10px 0 0'
          }}
        >
          {menuLabel}
        </div>
      )}
      <components.MenuList {...props}>{props.children}</components.MenuList>
    </>
  );
};

const CustomCreatableSelect = ({
  id,
  name,
  required = false,
  formatCreateLabel,
  isLoading = false,
  placeholder = 'Select an option',
  showLabel = true, // Determines if the label should be shown
  menuLabel = 'Pick from the options below or Type your own...', // Label text
  options = [],
  value,
  classNamePrefix = 'select',
  className = 'basic-single',
  onChange,
  menuPlacement = 'auto',
  ...rest
}) => {
  return (
    <CreatableSelect
      id={id}
      name={name}
      required={required}
      formatCreateLabel={
        formatCreateLabel ||
        (value => (
          <>
            Select <span className="font-weight-bold">"{value}"</span>
          </>
        ))
      }
      isLoading={isLoading}
      placeholder={placeholder}
      options={options}
      value={value}
      classNamePrefix={classNamePrefix}
      className={className}
      onChange={onChange}
      menuPlacement={menuPlacement}
      components={{
        MenuList: props => <CustomMenuList {...props} showLabel={showLabel} menuLabel={menuLabel} />
      }}
      {...rest}
    />
  );
};

export default CustomCreatableSelect;
